<template>
	<!-- VApp is an element which is required to use Vuetify. @see https://vuetifyjs.com/en/ for help -->
	<VApp v-cloak>
		<AppNavBar />

		<AppHeader />

		<NotificationBar data-cy="notificationBar" />

		<VMain>
			<!-- Transition between routes -->
			<transition
				name="fade"
				mode="out-in"
			>
				<!-- Load the component defined in the router for the current route -->
				<RouterView />
			</transition>
		</VMain>

		<AppFooter v-if="!$maintenanceEnabled" />
	</VApp>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { Meta, MetaInfo } from '@/decorators';

	// Static import for faster rendering
	import { AppNavBar, AppHeader, AppFooter } from '@/components/layout';

	/** App is the main component */
	@Component({
		components: {
			AppNavBar,
			AppHeader,
			AppFooter
		}
	})
	export default class App extends Vue {
		/** The meta informations of the route */
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				// If a sub-components does not specifies metaInfo.title, this title will be used
				title: 'Pharmacies de garde | ameli.fr | Assurance Maladie',
				// All titles will be injected into this template
				titleTemplate: '%s',
				meta: [
					{
						name: 'description',
						vmid: 'description', /** Used to avoid duplicated tags @see https://vue-meta.nuxtjs.org/faq/#unique-metadata */
						content: 'Trouvez les pharmacies de garde à proximité, ouvertes en journée le dimanche et les jours fériés, partout en France. Service officiel de l\'Assurance Maladie.'
					}
				]
			};
		}
	}
</script>
